
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punesightseeing() {



    const cardData =
    {
        keyword: 'Pune Sightseeing Taxi',
        heading: 'Platinum24 Cabs: Pune Sightseeing Taxi',
        headingDescription: ' Platinum24 Cabs provides comfortable Pune Sightseeing Taxi services, ideal for exploring the city’s historical landmarks, cultural sites, and modern attractions. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe and convenient travel with spacious seating and air-conditioned comfort. With professional chauffeurs who know Pune’s best tourist routes, we guarantee hassle-free travel to places like Shaniwar Wada, Aga Khan Palace, Dagdusheth Halwai Ganpati Temple, Saras Baug, and more. Platinum24 Cabs offers affordable full-day and half-day sightseeing packages, making your Pune city exploration smooth, reliable, and enjoyable.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, its majestic gates, fountains, and sprawling gardens narrate stories of valor and legacy. Though partially destroyed by fire in 1828, its ruins still captivate tourists. The evening light-and-sound show brings alive Bajirao and Mastani’s era. A must-visit for history lovers, it is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now houses a museum showcasing Gandhi’s personal belongings and rare photographs. Its Italian arches, sprawling lawns, and tranquil vibe make it a top tourist attraction. It is Pune’s historic gem of inspiration and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Perched on a hill, it offers trekking trails and panoramic Sahyadri views. Visitors explore bastions, memorials, and temples that echo Maratha bravery. Monsoon enhances its beauty with misty clouds and waterfalls. Locals serve rustic pithla-bhakri at the fort. Sinhagad is Pune’s perfect mix of adventure, history, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The grand idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of festivities. It is also known for charitable and cultural activities. The spiritual energy here is unmatched. Dagdusheth Temple is Pune’s divine cultural and spiritual heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. Its rock-cut sanctum, stone pillars, and Nandi mandapa reflect ancient Indian craftsmanship. Despite being in the heart of the city, it offers peace and a spiritual retreat. Evening aartis create a mystical aura. History lovers admire its timeless carvings. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and antiques from daily life. Its highlight is the recreated Mastani Mahal. Students and history lovers find it highly educational and engaging. The museum preserves traditions from across India’s regions. It is Pune’s cultural treasure chest of art and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The Parvati Temple atop the hill is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, blending devotion with adventure. The site also houses a small museum and shrines. Sunsets and sunrises from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across lush gardens, it offers meditation, yoga, and self-discovery programs. Japanese Zen gardens, swimming pools, and meditation halls enhance the experience. It attracts seekers from across the world. Visitors leave with peace and rejuvenation. Osho Ashram is Pune’s international center of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, photography, and picnics here. Seasonal flowers and greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of peace and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam on the Mutha River is a popular weekend retreat near Pune. It supplies water to the city while offering scenic landscapes of hills and waters. In monsoon, the dam overflows spectacularly, drawing crowds. Vendors serve hot corn and tea, adding to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural escape."
  }
],



      "services": [
    {
      "name": "Pune Sightseeing Taxi Service",
      "description": "Explore the cultural and historic beauty of the city with our Pune Sightseeing Taxi Service. Designed for travelers, tourists, and families alike, this service offers curated routes covering major attractions like Shaniwar Wada, Aga Khan Palace, Saras Baug, Parvati Hill, and more. Enjoy a guided experience with our well-trained drivers who know the city's best spots, hidden gems, and food joints. Whether you want a half-day city tour or a full-day exploration, our sightseeing taxis are air-conditioned, clean, and provide a safe, informative, and relaxing travel experience."
    },
    {
      "name": "Sightseeing Cab Pune",
      "description": "Our Sightseeing Cab in Pune offers the perfect way to explore the city’s historical landmarks, spiritual sites, and entertainment hubs. Choose from economy hatchbacks to spacious SUVs based on your group size. All cabs come with verified drivers familiar with tourist routes, ensuring a smooth and insightful journey. Ideal for solo travelers, couples, and families looking to explore Pune at their own pace with full comfort and flexibility."
    },
    {
      "name": "Pune City Tour Taxi",
      "description": "The Pune City Tour Taxi service offers a full-day or half-day curated experience covering the most iconic attractions of the city. From cultural monuments and museums to parks and temples, our city tour taxi ensures you make the most of your visit. It includes hotel/home pickup and drop, flexible stopovers, and expert drivers who share local insights along the way. Great for first-time visitors or weekend tourists looking for a complete Pune experience."
    },
    {
      "name": "Sightseeing Car Rental Pune",
      "description": "Rent a car for Pune sightseeing and enjoy unmatched flexibility and comfort. Choose between self-drive and chauffeur-driven options. Whether you’re planning to visit multiple locations like Rajiv Gandhi Zoological Park, Katraj Lake, and Dagdusheth Ganpati Temple or want to go off the beaten path, our fleet of clean, well-maintained vehicles ensures a convenient travel experience. Booking includes fuel, driver allowance, and customizable itineraries."
    },
    {
      "name": "Pune Tourist Taxi Service",
      "description": "Tailored for both domestic and international travelers, our Pune Tourist Taxi Service offers an informative and enjoyable way to explore the city’s top spots. With options for half-day, full-day, and multi-day packages, tourists can experience Pune's mix of tradition and modernity with knowledgeable drivers who double as local guides. Our cabs are equipped with GPS, bottled water, and multilingual support for a stress-free tour."
    },
    {
      "name": "Pune Local Sightseeing Cab",
      "description": "Our Pune Local Sightseeing Cab service is ideal for locals who want to spend the weekend rediscovering the city's charms or hosting guests. With door-to-door service, you can explore everything from ancient forts to modern malls. Perfect for families, couples, and small groups who want a relaxing, chauffeured city tour without the rush of public transport or the stress of driving."
    },
    {
      "name": "Sightseeing Taxi with Driver Pune",
      "description": "Book a Sightseeing Taxi with Driver in Pune for a completely relaxed and guided tour of the city. All our drivers are professionally trained and well-versed in tourist-friendly behavior. They provide insights into locations, help with entry fees if required, and even suggest the best time to visit each site. From historic landmarks to shopping districts, experience the city through a local’s eyes in a safe and friendly environment."
    },
    {
      "name": "Affordable Sightseeing Cabs Pune",
      "description": "Looking for a pocket-friendly way to tour the city? Our Affordable Sightseeing Cabs in Pune are perfect for budget-conscious travelers. Enjoy clean, reliable, and AC-enabled cabs with courteous drivers at unbeatable rates. We offer economical packages without compromising on comfort, so you can explore more for less. Ideal for students, families, or solo explorers wanting value-based travel options."
    },
    {
      "name": "Pune Heritage Tour Taxi",
      "description": "Dive into Pune’s rich historical past with our Pune Heritage Tour Taxi. Visit ancient forts, British-era buildings, old city markets, and temples all in one curated heritage tour. Learn about the Maratha Empire, Peshwa rulers, and colonial influences through well-planned routes and knowledgeable drivers who act as informal guides. Perfect for culture enthusiasts, school trips, and history lovers."
    },
    {
      "name": "Pune Sightseeing Packages",
      "description": "Our Pune Sightseeing Packages include full-day, half-day, and customizable tour plans that cover Pune’s most famous attractions. The packages offer fixed pricing, optional tour guides, and free itinerary consultation. Choose themes like heritage, nature, temples, or urban hotspots and get a cab that suits your group size and preferences. All-inclusive rates make it easy to plan your sightseeing without surprises."
    },
    {
      "name": "Pune Local Travel Taxi",
      "description": "Use our Pune Local Travel Taxi for flexible and convenient travel around the city. Whether it’s for business, leisure, or local exploration, this service allows you to book a cab by the hour or day. Choose pickup/drop points, stopovers, and travel time as per your schedule. Our drivers are punctual and polite, ensuring a smooth intra-city travel experience with no meter hassles."
    },
    {
      "name": "Pune Sightseeing Cab Booking",
      "description": "Pune Sightseeing Cab Booking is now easy with our user-friendly app and website. Choose from various cab types, select your route or choose from preset itineraries, and get instant confirmation. Book in advance or on the spot – our large network ensures availability even on weekends and holidays. Includes real-time tracking, driver details, and customer support for complete peace of mind."
    },
    {
      "name": "Pune Weekend Sightseeing Taxi",
      "description": "Make your weekends special with our Pune Weekend Sightseeing Taxi service. Escape the routine and explore the cultural gems, nature spots, and food streets of Pune with your loved ones. Whether it’s a romantic getaway or a family picnic, our weekend packages include flexible pickup times, extended hours, and optional add-ons like refreshments or guide services for a complete experience."
    },
    {
      "name": "Pune Tourist Cab Service",
      "description": "Our Pune Tourist Cab Service caters to individuals, families, and tour groups who want to experience the best of Pune with maximum comfort and zero stress. From airport pickups to guided city tours, this service includes everything a tourist needs to feel welcomed and relaxed. Drivers are multilingual and trained in hospitality, ensuring your sightseeing trip is not just informative, but also enjoyable."
    },
    {
      "name": "Pune Sightseeing Taxi Deals",
      "description": "Take advantage of exclusive Pune Sightseeing Taxi Deals with seasonal discounts, combo offers, and cashback options. Whether you’re planning a solo trip or a group tour, our deals help you save while enjoying premium service. Look out for festive offers, student discounts, and loyalty benefits that make city tours more affordable and accessible."
    }
  ],
  "tableData": [
    ["Pune Sightseeing Taxi Service", "Sightseeing Cab Pune"],
    ["Pune City Tour Taxi", "Sightseeing Car Rental Pune"],
    ["Pune Tourist Taxi Service", "Pune Local Sightseeing Cab"],
    ["Sightseeing Taxi with Driver Pune", "Affordable Sightseeing Cabs Pune"],
    ["Pune Heritage Tour Taxi", "Pune Sightseeing Packages"],
    ["Pune Local Travel Taxi", "Pune Sightseeing Cab Booking"],
    ["Pune Weekend Sightseeing Taxi", "Pune Tourist Cab Service"],
    ["Pune Sightseeing Taxi Deals", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Explore the City with Pune Sightseeing Taxi Service",
      "WhyChoosedescription": "Platinum24 Cabs offers convenient and comfortable taxi services for local sightseeing across Pune."
    },
    {
      "WhyChooseheading": "Customizable Sightseeing Packages",
      "WhyChoosedescription": "Choose from half-day, full-day, or tailor-made tour packages covering Pune’s top attractions."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Knowledge",
      "WhyChoosedescription": "Our drivers are familiar with all major tourist spots in Pune and act as your local guide on the go."
    },
    {
      "WhyChooseheading": "Clean, Air-Conditioned, and Comfortable Cabs",
      "WhyChoosedescription": "Travel in well-maintained, sanitized vehicles that ensure a relaxing experience throughout your tour."
    },
    {
      "WhyChooseheading": "Perfect for Families, Solo Travelers, and Groups",
      "WhyChoosedescription": "Whether you're traveling alone or with family/friends, we have the right vehicle to match your group size."
    },
    {
      "WhyChooseheading": "Flexible Pickup and Drop Timings",
      "WhyChoosedescription": "Plan your day at your pace with flexible scheduling and convenient door-to-door service."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
      "WhyChoosedescription": "Enjoy clear, all-inclusive pricing covering fuel, driver allowance, and parking at major attractions."
    },
    {
      "WhyChooseheading": "24/7 Support and Easy Booking",
      "WhyChoosedescription": "Book online or through our support team anytime—perfect for last-minute travel plans or weekend tours."
    }
  ]





























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune sightseeing taxi services?',
        answer: 'Yes, Platinum24 Cabs offers dedicated taxi services for sightseeing in Pune, covering major tourist attractions comfortably and conveniently.',
    },
    {
        question: 'How can I book a Pune sightseeing taxi with Platinum24 Cabs?',
        answer: 'You can book a sightseeing taxi through our website, mobile app, or by calling our customer support for customized packages.',
    },
    {
        question: 'What places are included in the Pune sightseeing taxi package?',
        answer: 'Popular sightseeing spots include Shaniwar Wada, Aga Khan Palace, Dagdusheth Halwai Ganpati Temple, Saras Baug, Parvati Hills, Sinhagad Fort, and more.',
    },
    {
        question: 'Can I customize my Pune sightseeing itinerary?',
        answer: 'Yes, we offer fully customizable sightseeing packages based on your preferences and the time you have available.',
    },
    {
        question: 'What types of vehicles are available for sightseeing in Pune?',
        answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to suit your group size and comfort needs.',
    },
    {
        question: 'Is the sightseeing taxi service available for full day and half day?',
        answer: 'Yes, we provide both half-day and full-day sightseeing taxi options with hourly rental packages.',
    },
    {
        question: 'Are drivers knowledgeable about tourist places in Pune?',
        answer: 'Yes, our drivers are familiar with all major tourist attractions and can guide you through the best sightseeing routes.',
    },
    {
        question: 'Are safety and hygiene maintained in sightseeing taxis?',
        answer: 'Absolutely. All vehicles are regularly sanitized and our drivers follow strict hygiene and safety protocols.',
    },
    {
        question: 'Can I book a Pune sightseeing taxi for a group or family?',
        answer: 'Yes, we have larger vehicles and tempo travellers suitable for group and family sightseeing tours in Pune.',
    },
    {
        question: 'Do you offer guided Pune sightseeing tours as well?',
        answer: 'Yes, we can arrange professional tour guides upon request for a more informative sightseeing experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Naik',
        feedback: 'Our Pune sightseeing trip with Platinum24 Cabs was fantastic. The driver knew all the best spots and routes.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Pooja Sawant',
        feedback: 'Booked a full-day sightseeing cab in Pune — clean car, friendly driver, and great experience overall. Highly recommended!',
        rating: 5,
    },
];





















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneSightseeingTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable Pune sightseeing taxi service offering city tours, heritage tours, weekend sightseeing, and tourist cab packages with professional drivers.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Pune Sightseeing Taxi Service",
    "Sightseeing Cab Pune",
    "Pune City Tour Taxi",
    "Sightseeing Car Rental Pune",
    "Pune Tourist Taxi Service",
    "Pune Local Sightseeing Cab",
    "Sightseeing Taxi with Driver Pune",
    "Affordable Sightseeing Cabs Pune",
    "Pune Heritage Tour Taxi",
    "Pune Sightseeing Packages",
    "Pune Local Travel Taxi",
    "Pune Sightseeing Cab Booking",
    "Pune Weekend Sightseeing Taxi",
    "Pune Tourist Cab Service",
    "Pune Sightseeing Taxi Deals"
  ],
  "telephone": "+91-XXXXXXXXXX"
};





    return (
        <div>

<Helmet>
  <title>Pune Sightseeing Taxi Service | City Tour & Heritage Cab Booking Pune</title>
  <meta
    name="description"
    content="Reliable and affordable Pune sightseeing taxi service offering city tours, heritage tours, weekend sightseeing, and tourist cab packages with professional drivers."
  />
  <meta
    name="keywords"
    content="Pune Sightseeing Taxi Service, Sightseeing Cab Pune, Pune City Tour Taxi, Sightseeing Car Rental Pune, Pune Tourist Taxi Service, Pune Local Sightseeing Cab, Sightseeing Taxi with Driver Pune, Affordable Sightseeing Cabs Pune, Pune Heritage Tour Taxi, Pune Sightseeing Packages, Pune Local Travel Taxi, Pune Sightseeing Cab Booking, Pune Weekend Sightseeing Taxi, Pune Tourist Cab Service, Pune Sightseeing Taxi Deals"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneSightseeingTaxiSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punesightseeing;